import { Info } from 'lucide-react'

export default function InfoBanner() {
  return (
    <div className="w-full bg-blue-500 text-white py-2 px-4 flex items-center justify-center gap-2 shadow-md">
      <Info className="h-4 w-4 flex-shrink-0" />
      <p className="text-sm font-medium text-center">
        Clearbit Logo API was discontinued so logos are broken. Fixing soon!
      </p>
    </div>
  )
}
